<div class="flex-fill d-flex flex-column ps-2">
    <div class="d-flex flex-row flex-shrink-0 sidebar">
        @if (canSeeQB) {
            <span class="d-flex flex-column mt-1">
                <div class="m-0">
                    <strong> Quickbooks Online</strong>
                </div>
                <div class="d-flex flex-row mb-2">
                    <button class="btn btn-success me-1" (click)="connectToQuickbooks()">Connect</button>
                    <button class="btn btn-danger me-2" (click)="disconnect()">Disconnect</button>
                    <dx-select-box
                        class="me-2"
                        [(value)]="filter.selectedEntityType"
                        [items]="types"
                        (onValueChanged)="typeChanged($event)"
                        [disabled]="processing"
                    ></dx-select-box>
                    <button class="btn btn-success me-4" (click)="refresh()">Refresh Data</button>
                    <div>
                        <button class="btn btn-sm btn-primary me-2" (click)="getAccountsOrProducts('Products')">Get Products</button>
                        <button class="btn btn-sm btn-primary me-4" (click)="getAccountsOrProducts('Accounts')">Get Accounts</button>
                        <button class="btn btn-sm btn-danger" (click)="addJournalEntry()">Add Journal Entry</button>
                    </div>
                </div>
            </span>
        }
    </div>
    <div class="d-flex flex-fill flex-row">
        <div class="col-sm-5">
            <dx-data-grid #dataGrid [keyExpr]="'id'" [dataSource]="data" class="grid-fill flex-fill h-100">
                <dxi-column dataField="id" caption="Id" width="70"></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Customer' || filter.selectedEntityType === 'Vendor'"
                    dataField="displayName"
                    caption="Customer/Vendor"
                    cellTemplate="linkTemplate"
                    width="450"
                ></dxi-column>

                <dxi-column
                    [visible]="filter.selectedEntityType === 'Invoice' || filter.selectedEntityType === 'Credit'"
                    dataField="invoiceDate"
                    caption="Date"
                    width="90"
                ></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Invoice' || filter.selectedEntityType === 'Credit'"
                    dataField="invoiceNumber"
                    [caption]="filter.selectedEntityType === 'Invoice' ? 'Invoice #' : 'Credit #'"
                    cellTemplate="linkTemplate"
                    width="70"
                ></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Credit'"
                    dataField="referencedInvoice.invoiceNumber"
                    caption="Referenced Invoice #"
                    cellTemplate="linkTemplate"
                    width="140"
                ></dxi-column>
                <dxi-column [visible]="filter.selectedEntityType === 'Payment'" dataField="paymentDate" caption="Date" width="90"></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Payment'"
                    dataField="paymentLines[0].invoice.invoiceNumber"
                    caption="Invoice #"
                    cellTemplate="linkTemplate"
                    width="70"
                ></dxi-column>
                <dxi-column [visible]="filter.selectedEntityType === 'Payment'" dataField="referenceNumber" caption="Ref #" width="70"></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Invoice' || filter.selectedEntityType === 'Credit' || filter.selectedEntityType === 'Payment'"
                    dataField="customer.displayName"
                    caption="Customer"
                    cellTemplate="linkTemplate"
                    width="250"
                ></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Invoice' || filter.selectedEntityType === 'Credit'"
                    dataField="total"
                    [format]="{ type: 'currency', precision: 2 }"
                    caption="Amount"
                    width="125"
                ></dxi-column>
                <dxi-column
                    [visible]="filter.selectedEntityType === 'Payment'"
                    dataField="paymentAmount"
                    [format]="{ type: 'currency', precision: 2 }"
                    caption="Amount"
                    width="70"
                ></dxi-column>

                <dxi-column [visible]="filter.selectedEntityType === 'Journal Entry'" dataField="journalEntryDate" caption="Date" width="90"></dxi-column>
                <dxi-column [visible]="filter.selectedEntityType === 'Journal Entry'" dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="70"></dxi-column>
                <dxi-column [visible]="filter.selectedEntityType === 'Journal Entry'" dataField="creditAccount.name" caption="Credit Account" width="150"></dxi-column>
                <dxi-column [visible]="filter.selectedEntityType === 'Journal Entry'" dataField="debitAccount.name" caption="Debit Account" width="150"></dxi-column>

                <dxi-column width="50"></dxi-column>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    @if (cell) {
                        <a [routerLink]="[]" [innerHtml]="cell.text" (click)="openFromQueue(cell.data, cell.column.dataField)"></a>
                    }
                </div>

                <dxo-selection [mode]="'multiple'"></dxo-selection>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="quickbooks-overview-grid"></dxo-state-storing>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-success me-1 mb-2" (click)="export()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Export Selected</button>
                    <button
                        class="btn btn-sm btn-success ms-4 me-1 mb-2"
                        (click)="markAsExported()"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || dataGrid.instance.getSelectedRowsData()[0]?.quickBooksId"
                    >
                        Mark As Exported
                    </button>
                </div>

                <div *dxTemplate="let data of 'toolbarText'">
                    @if (data) {
                        <span class="me-3">
                            <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
                        </span>
                    }
                </div>
            </dx-data-grid>
        </div>

        <div class="col-sm-7">
            <dx-data-grid #quickbooksSyncResultsGrid keyExpr="id" class="grid-fill flex-fill h-100" [dataSource]="responses" [showBorders]="true">
                <dxi-column dataField="id" caption="Id" width="65" alignment="left"></dxi-column>
                <dxi-column dataField="type" caption="Type" width="80"></dxi-column>
                <dxi-column dataField="customerName" caption="Customer" cellTemplate="customerTemplate" width="200"></dxi-column>
                <dxi-column dataField="status" width="100" alignment="left"></dxi-column>
                <dxi-column dataField="message" alignment="left" width="200"></dxi-column>
                <dxi-column dataField="invoice.invoiceNumber" caption="Invoice #" cellTemplate="linkTemplate" width="100"></dxi-column>
                <dxi-column dataField="paymentId" caption="Payment Id" width="100" alignment="left" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="customerId" caption="Customer Id" width="100" alignment="left" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="invoiceId" caption="Invoice Id" width="100" alignment="left" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="vendorId" caption="Vendor Id" width="100" alignment="left" cellTemplate="linkTemplate"></dxi-column>

                <dxi-column dataField="payment?.checkNumber" caption="Ref #" cellTemplate="linkTemplate" width="70"></dxi-column>

                <dxi-column dataField="created" width="100"></dxi-column>
                <dxi-column dataField="quickBooksTaskId" caption="Task Id" width="65" alignment="left"></dxi-column>
                <dxi-column width="55"></dxi-column>

                <div *dxTemplate="let cell of 'customerTemplate'">
                    @if (cell) {
                        <a [routerLink]="[]" [innerHtml]="cell.text" (click)="openResponsesData(cell.data, 'customerDisplayName')"> </a>
                    }
                </div>
                <div *dxTemplate="let cell of 'linkTemplate'">
                    @if (cell) {
                        <a [routerLink]="[]" [innerHtml]="cell.text" (click)="openResponsesData(cell.data, cell.column.dataField)"></a>
                    }
                </div>
                <div *dxTemplate="let data of 'toolbarButtons'"></div>
                <div *dxTemplate="let data of 'toolbarText'">
                    @if (responses) {
                        <span class="me-3">
                            <strong>{{ quickbooksSyncResultsGrid.instance.totalCount() + " items" }}</strong>
                        </span>
                    }
                </div>

                <dxo-search-panel [visible]="true"></dxo-search-panel>
                <dxo-selection [mode]="'single'"></dxo-selection>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" [storageKey]="'quickbooks-sync-grid'"></dxo-state-storing>
            </dx-data-grid>
        </div>
    </div>
</div>
